import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { Router } from '@angular/router';
import { AuthAccessProvider } from '../core/core.auth';
import { UserContext, BaseComponent, UserStatistics, UserStatisticsResponse} from '../core/core.component';
import { MessageProvider } from '../service/message.service';
import { PresenzeService} from '../service/presenze.service';
import { Subscription } from 'rxjs/Subscription';
import { Subject } from 'rxjs/Subject';

@Component({
  selector: 'app-statistics',
  templateUrl: './statistics.component.html',
  styleUrls: ['./statistics.component.css']
})
export class StatisticsComponent extends BaseComponent implements OnInit, OnDestroy
{
    statistics: UserStatistics = new UserStatistics();
    userContext: UserContext = null;
    @Input() refresh: Subject<boolean>;
    refreshSubscripton : Subscription = null;
    constructor(protected authAccess: AuthAccessProvider, 
            protected router: Router,
            protected messageProvider: MessageProvider, 
            private presenzeService: PresenzeService)  
    {
        super(authAccess, router, messageProvider);
    }

  ngOnInit() 
  {
      this.userContext = this.authAccess.getUserContext();
      this.refreshSubscripton = 
          this.refresh.asObservable().subscribe(value => { this.load(); });
      if(this.userContext != null) {
          this.load();
      }
      else {
          this.authAccess.invalidate();
      }
  }
  
  ngOnDestroy()
  {
      if(this.refreshSubscripton != null) {
          this.refreshSubscripton.unsubscribe();
      }
  }
  
  private load()
  {
      var res: UserStatisticsResponse;
      this.presenzeService.getUserStatistics(this.userContext.srmToken).
       subscribe(response => {
           res = response;
           this.statistics = res.map;
       }, 
       error => {
           this.handleError(error);
       });   
  }

}



// WEBPACK FOOTER //
// ./src/app/statistics/statistics.component.ts